import { render, staticRenderFns } from "./data-table-create-calculation-delivery.vue?vue&type=template&id=5f633f5e&scoped=true&"
import script from "./data-table-create-calculation-delivery.vue?vue&type=script&lang=js&"
export * from "./data-table-create-calculation-delivery.vue?vue&type=script&lang=js&"
import style0 from "./data-table-create-calculation-delivery.vue?vue&type=style&index=0&id=5f633f5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f633f5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f633f5e')) {
      api.createRecord('5f633f5e', component.options)
    } else {
      api.reload('5f633f5e', component.options)
    }
    module.hot.accept("./data-table-create-calculation-delivery.vue?vue&type=template&id=5f633f5e&scoped=true&", function () {
      api.rerender('5f633f5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/calculations/create/additions/data-table-create-calculation-delivery.vue"
export default component.exports